import * as Model from "./event-quota.model";
import * as Util from "./event-quota.util";
import * as Schedule from "./event-quota.schedule";
import * as Exceeded from "./event-quota.exceeded-message";
import { EventQuotaFormValidators } from "./event-quota.form-validators";

export namespace EventQuota {
    export type DurationNameMap = Model.DurationNameMap;
    export import durationNameMap = Model.durationNameMap;
    export import NAME_MAX_LENGTH = Model.NAME_MAX_LENGTH;
    export import DURATION_TYPE_MAX_LENGTH = Model.DURATION_TYPE_MAX_LENGTH;
    export import EDITOR_DURATION_TYPES = Model.EDITOR_DURATION_TYPES;
    export import MAX_ROLLING_DURATION_BY_UNIT = Model.MAX_ROLLING_DURATION_BY_UNIT;
    export import MAX_FIXED_WINDOW_DAYS = Model.MAX_FIXED_WINDOW_DAYS;
    export import windowModeNameMap = Model.windowModeNameMap;
    export type WindowMode = Model.WindowMode;
    export import DURATION_WINDOW_MODES = Model.DURATION_WINDOW_MODES;
    export import FIXED_WINDOW_MODES = Model.FIXED_WINDOW_MODES;
    export type WindowModeNameMap = Model.WindowModeNameMap;
    export import DEFAULT_WINDOW_MODE = Model.DEFAULT_WINDOW_MODE;
    export type OrgScopeMode = Model.OrgScopeMode;
    export type FormModel = Model.FormModel;
    export type SelectionBaseline = Model.SelectionBaseline;
    export type RawData = Model.RawData;
    export type JsonOutput = Model.JsonOutput;
    export type Detailed = Model.Detailed;
    export type Type = Model.Type;
    export import TypeIds = Model.TypeIds;
    export import ObjectTypeIds = Model.ObjectTypeIds;
    export type QuotaScopeItem = Model.QuotaScopeItem;
    export type CheckOccurrence = Model.CheckOccurrence;
    export type CheckResult = Model.CheckResult;
    export type LocationItem = Model.LocationItem;
    export type CheckResultMessageContext = Model.CheckResultMessageContext;

    export import toQuotaTypeId = Util.toQuotaTypeId;
    export import hasMeaningfulMaxTimeHoursMinutes = Util.hasMeaningfulMaxTimeHoursMinutes;
    export import normalizeWindowMode = Util.normalizeWindowMode;
    export import windowModeLabel = Util.windowModeLabel;
    export import usesDurationForWindow = Util.usesDurationForWindow;
    export import usesFixedDatesForWindow = Util.usesFixedDatesForWindow;
    export import windowDateLabels = Util.windowDateLabels;
    export import timeWindowLabel = Util.timeWindowLabel;
    export import hasCountLimit = Util.hasCountLimit;
    export import hasTimeLimit = Util.hasTimeLimit;
    export import exceededPeriodPhrase = Exceeded.exceededPeriodPhrase;
    export import exceededCountLimitPhrase = Exceeded.exceededCountLimitPhrase;
    export import exceededTimeLimitPhrase = Exceeded.exceededTimeLimitPhrase;
    export import formatCheckResultExceededMessage = Exceeded.formatCheckResultExceededMessage;
    export import formatCheckResultsExceededMessage = Exceeded.formatCheckResultsExceededMessage;
    export import durationForPayload = Util.durationForPayload;
    export import maxRollingDurationForUnit = Util.maxRollingDurationForUnit;
    export import rollingDurationLimitMessage = Util.rollingDurationLimitMessage;
    export import rollingPeriodLengthHelpText = Util.rollingPeriodLengthHelpText;
    export import fixedWindowSpanHelpText = Util.fixedWindowSpanHelpText;
    export import fixedWindowSpanDays = Util.fixedWindowSpanDays;
    export import exceedsFixedWindowSpanLimit = Util.exceedsFixedWindowSpanLimit;
    export import exceedsForwardFromTodaySpanLimit = Util.exceedsForwardFromTodaySpanLimit;
    export import formDateFromServer = Util.formDateFromServer;
    export import formPickerDateFromServer = Util.formPickerDateFromServer;
    export import serverDateFromForm = Util.serverDateFromForm;

    export import DOW_ABBRS = Schedule.DOW_ABBRS;
    export import DAY_LABELS = Schedule.DAY_LABELS;
    export import ALL_DOW = Schedule.ALL_DOW;
    export import WEEKDAY_DOW = Schedule.WEEKDAY_DOW;
    export import normalizeDow = Schedule.normalizeDow;
    export import selectionFromDow = Schedule.selectionFromDow;
    export import dowFromSelection = Schedule.dowFromSelection;
    export import formatTimeForInput = Schedule.formatTimeForInput;
    export import formatTimeForServer = Schedule.formatTimeForServer;
    export import scheduleSummaryLabel = Schedule.scheduleSummaryLabel;

    export import Validators = EventQuotaFormValidators;
}
